// PublicRunView.js - View public run results
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import TimerPage from './TimerPage';

const PublicRunView = () => {
  const { runId } = useParams();
  const [run, setRun] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRun = async () => {
      if (!runId) {
        setError('Invalid run ID');
        setLoading(false);
        return;
      }

      try {
        const runDoc = await getDoc(doc(db, 'events', runId));
        if (!runDoc.exists()) {
          setError('Run not found');
          setLoading(false);
          return;
        }

        const runData = runDoc.data();
        if (!runData.isPublic) {
          setError('This run is not publicly available');
          setLoading(false);
          return;
        }

        setRun({ id: runDoc.id, ...runData });
      } catch (err) {
        console.error('Error loading public run:', err);
        setError('Failed to load run');
      } finally {
        setLoading(false);
      }
    };

    loadRun();
  }, [runId]);

  if (loading) {
    return (
      <div style={{ 
        width: '100%', 
        padding: '40px 20px', 
        textAlign: 'center' 
      }}>
        <p>Loading run...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        width: '100%', 
        padding: '40px 20px', 
        textAlign: 'center' 
      }}>
        <p style={{ color: '#d32f2f' }}>{error}</p>
      </div>
    );
  }

  // Redirect to timer page with the run ID
  // The timer page will handle public viewing
  return <TimerPage />;
};

export default PublicRunView;
